import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import './ProjectResult.css'
import ProjectTag from './ProjectTag';

function ProjectResult(props) {

    const navigate = useNavigate();

    const projectID = props?.result?.project_id || -1;
    const projectName = props?.result?.name || 'Project Name';
    const sponsorName = props?.result?.sponsor || 'Sponsor Name';
    const endSemester = props?.result?.end_semester || 'Semester';
    const endYear = props?.result?.end_year || '';
    const description = props?.result?.description || 'No description provided.';
    const tags = props?.result?.tags || [];

    let onClick = () => { }

    if (projectID !== -1) {
        onClick = () => { navigate(`/projects/${projectID}`) }
    }

    return (
        <div className='projresult' onClick={onClick}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '50%' }}>
                <Typography variant='h6' sx={{ fontWeight: 'bold', width: '33%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{projectName}</Typography>
                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>{sponsorName}</Typography>
                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>{endSemester + ' ' + endYear}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '50%', pt: 1 }}>
                <Typography variant='subtitle' sx={{ fontSize: '18px', fontStyle: 'italic', width: '65%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                    {description}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                    {tags.map(tag => <ProjectTag tag={tag.name} key={`tag${tag.name}`} />)}
                </Box>
            </Box>
        </div>
    );
}

export default ProjectResult;